(function exactHeaderFix() {
    const style = document.createElement('style');
    style.innerHTML = `
      /* Target the specific desktop button using escaped colon \\: */
      search-button.mobile\\:hidden button {
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        align-items: center !important;
        width: 420px !important;
        border-radius: 999px !important;
        border: 1px solid #e5e7eb !important;
        padding: 0 20px !important;
        background-color: #ffffff !important;
      }
      
      /* The injected animated text */
      search-button.mobile\\:hidden button .custom-animated-text {
        display: block !important;
        flex-grow: 1 !important;
        text-align: left !important;
        font-size: 15px !important;
        color: #374151 !important;
        pointer-events: none !important;
        white-space: nowrap !important;
        order: 1 !important; /* Locks text to the left */
      }

      /* Keep the icon strictly on the right */
      search-button.mobile\\:hidden button .svg-wrapper {
        display: flex !important;
        align-items: center !important;
        margin: 0 !important;
        order: 2 !important; /* Locks icon to the right */
      }
    `;
    document.head.appendChild(style);

    //  TYPING ANIMATION ENGINE
    const searchItems = [
      "Mustard Oil", "Basmati Rice", "Whole Wheat Atta", 
      "Turmeric Powder", "Sea Salt", "Almonds & Cashews", 
      "Tomato Ketchup", "Fresh Milk", "Paneer"
    ];
    
    let currentIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function typeLoop() {
      const textElements = document.querySelectorAll('.custom-animated-text');
    
      if (textElements.length === 0 || window.innerWidth < 768) {
        setTimeout(typeLoop, 1000);
        return;
      }

      const currentWord = searchItems[currentIndex];
      let speed = isDeleting ? 40 : 80;
      
      // Extract the word being typed
      const typedText = currentWord.substring(0, charIndex);
      
      // Inject HTML with the colored span for the typed item
      const htmlToShow = `Search for <span style="color: #f18a1b;">${typedText}</span>|`;
      
      // Use innerHTML instead of innerText so the browser reads the span style
      textElements.forEach(el => el.innerHTML = htmlToShow);

      if (!isDeleting && charIndex === currentWord.length) {
        isDeleting = true;
        speed = 1500; 
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        currentIndex = (currentIndex + 1) % searchItems.length;
        speed = 400; 
      } else {
        charIndex += isDeleting ? -1 : 1;
      }

      setTimeout(typeLoop, speed);
    }

    setInterval(() => {
      const desktopBtns = document.querySelectorAll('search-button.mobile\\:hidden button');
      
      desktopBtns.forEach(btn => {
        if (!btn.querySelector('.custom-animated-text')) {
          const textSpan = document.createElement('span');
          textSpan.className = 'custom-animated-text';
          btn.insertBefore(textSpan, btn.firstChild);
        }
      });
    }, 500);

    typeLoop();
  })();